import React from 'react';
import cx from 'classnames';
import { isEmail } from 'validator';
import memoizeOne from 'memoize-one';
import { getStringValueFromGenericInput } from '@shootsta/get-value-from-generic-input';
import _memoize from 'lodash.memoize';
import {
  Row,
  Col,
  Input,
  Container,
  Button,
  PhoneNumberInput,
  Text,
  Link,
  FormModal } from '../../../ui-kit';
import '../styles/__register-interest.scss';














const isValidEmail = memoizeOne(isEmail);

function RegisterInterestModal({
  visible,
  onSave,
  onClose,
  saveText,
  stayOpen,
  title,
  subtitle,
  error,
  className
}) {
  const [userInput, setUserInput] = React.useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: ''
  });

  const [saving, setSaving] = React.useState(false);
  const [formError, setError] = React.useState('');

  const [phoneNumberValid, setValidPhoneNumber] = React.useState(true);

  const isValidForm = () => phoneNumberValid &&
  isValidEmail &&
  Boolean(userInput.firstName) &&
  Boolean(userInput.email) &&
  Boolean(userInput.phoneNumber) &&
  Boolean(userInput.lastName);

  function privacyPolicyClick() {
    window.open('https://shootsta.com/legal-stuff/', '_blank');
  }

  const updateInputField = _memoize((fieldName) => (result) => {
    setUserInput({
      ...userInput,
      [fieldName]: getStringValueFromGenericInput(result)
    });
  });

  const onValidatePhoneNumber = (valid) => {
    setValidPhoneNumber(valid);
  };

  const onSaveForm = async () => {
    setSaving(true);
    if (!isValidForm()) {
      setError('Please enter valid form details');
    }
    if (onSave && isValidForm()) {
      await onSave(userInput);
    }
    setSaving(false);
  };

  return (
    <div className={cx('register-interest-modal', className)}>
      <FormModal
        visible={visible}
        hideFooter
        title={title}
        subtitle={subtitle}
        saveText={saveText}
        onClose={onClose}
        stayOpenOnSave={stayOpen}>

        <Container fluid className="register-interest-modal__form">
          <Row className="register-interest-modal__row">
            <Col>
              <Input
                className="register-interest-modal__first-name"
                data-testid="register-interest-first-name"
                validate={() => Boolean(userInput.firstName)}
                label="First Name"
                onChange={updateInputField('firstName')}
                value={userInput.firstName}
                labelProps={{ required: true }} />

            </Col>
            <Col>
              <Input
                className="register-interest-modal__last-name"
                data-testid="register-interest-last-name"
                label="Last Name"
                validate={() => Boolean(userInput.lastName)}
                onChange={updateInputField('lastName')}
                value={userInput.lastName}
                labelProps={{ required: true }} />

            </Col>
          </Row>
          <Row className="register-interest-modal__row">
            <Col>
              <Input
                className="register-interest-modal__email"
                data-testid="register-interest-email"
                label="Email"
                onChange={updateInputField('email')}
                validate={isValidEmail}
                value={userInput.email}
                labelProps={{ required: true }}
                errorMessage="Please enter a valid email address" />

            </Col>
            <Col>
              <PhoneNumberInput
                id="contactnumber-input"
                className="register-interest-modal__phone-number"
                data-testid="register-interest-phone-number"
                placeholder="xxxx-xxx-xxx"
                label="Phone Number"
                labelProps={{ required: true }}
                onChange={updateInputField('phoneNumber')}
                onValidate={onValidatePhoneNumber}
                initialNumber={userInput.phoneNumber}
                value={userInput.phoneNumber} />

            </Col>
          </Row>
          <Row className="register-interest-modal__row">
            <Col>
              <Text block className="register-interest-modal__disclaimer">
                Shootsta needs the contact information you provide to us to
                contact you about our products and services. You may unsubscribe
                from these communications at ant time. For information on how to
                unsubscribe, as well as our privacy practices and commitment to
                protecting your privacy, please review our
                {' '}
                <Link
                  className="register-interest-modal__link"
                  onClick={() => {privacyPolicyClick();}}>

                  Privacy Policy
                </Link>
              </Text>
            </Col>
          </Row>
          {(formError || error) &&
          <Row className="register-interest-modal__row">
              <Col>
                <Text danger>{formError || error || ''}</Text>
              </Col>
            </Row>}


          <Row
            align="center"
            justify="center"
            className="register-interest-modal__row">

            <Col md={4} sm={12}>
              <Button
                onClick={onSaveForm}
                className="register-interest-modal__btn"
                busy={saving}
                disabled={!isValidForm()}>

                Submit
              </Button>
            </Col>
          </Row>
        </Container>
      </FormModal>
    </div>);

}

export default RegisterInterestModal;